import Vue from "vue";
import axios from "axios";
import { TokenService, StorageService } from "./StorageService";
import router from "../router/index";

let vademecumUrl = "";

const ApiService = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL;
  },

  setVademecumUrl(url) {
    vademecumUrl = url;
  },

  getVademecumUrl() {
    return vademecumUrl;
  },

  // Root origin (no path) used to open the session websocket, since it bypasses the REST API prefix.
  getSocketUrl() {
    return new URL(axios.defaults.baseURL).origin;
  },

  getHostAndPort() {
    const baseUrl = axios.defaults.baseURL.split("://");
    return baseUrl.length === 1 ? baseUrl[0] : baseUrl[1];
  },

  setHeader() {
    axios.defaults.headers.common["authorization"] = TokenService.getToken();
    const userData = StorageService.getUserData();
    axios.defaults.headers.common["user-id"] = userData ? userData.id : "";
    axios.defaults.headers.common["x-request-public-key"] =
      process.env.VUE_APP_CLIENT_KEY;
  },

  removeHeader() {
    axios.defaults.headers.common = {};
  },

  get(resource) {
    return axios.get(resource);
  },

  post(resource, data) {
    return axios.post(resource, data);
  },

  postFile(resource, file) {
    const formData = new FormData();
    const headers = { "Content-Type": "multipart/form-data" };
    formData.append("file", file);
    return axios.post(resource, formData, { headers });
  },

  postFiles(resource, files) {
    const formData = new FormData();
    const headers = { "Content-Type": "multipart/form-data" };
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      formData.append("files", file);
    }
    return axios.post(resource, formData, { headers });
  },

  put(resource, data) {
    return axios.put(resource, data);
  },

  delete(resource) {
    return axios.delete(resource);
  },

  patch(resource, data) {
    return axios.patch(resource, data);
  },

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    return axios(data);
  }
};

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    let message = null;
    let response = error.response;
    const requestUrl =
      error && error.config && error.config.url ? error.config.url : "";

    if (response) {
      if (response.status === 401) {
        const isSessionValidation = requestUrl.includes("/auth/validate");
        const reason = isSessionValidation ? "replaced" : "expired";
        message = isSessionValidation
          ? "Detectamos un inicio de sesión en otro dispositivo o ubicación. Por seguridad, cerramos esta sesión."
          : "Su sesión expiró, vuelva a ingresar su usuario y contraseña.";
        StorageService.clearStorage();
        ApiService.removeHeader();
        localStorage.setItem("session-expiration-message", message);
        window.dispatchEvent(new Event("app:force-logout"));
        router.push({ path: "/login", query: { reason } });
      } else if (response.status === 500) {
        message =
          "La aplicación no está respondiendo a las peticiones, por favor intente más tarde.";
      }
    }

    if (message) {
      Vue.notify({
        group: "app",
        type: "error",
        text: message
      });
    }

    return Promise.reject(response.data);
  }
);

export default ApiService;
